import { createEvent, createStore } from "effector";
import { AppConfig } from "../../config";

export const $currentLocale = createStore<typeof AppConfig.locales[0]>(
  AppConfig.locales[0]
);
export const setCurrentLocale = createEvent<string>("SET_LOCALE");
$currentLocale.on(setCurrentLocale, (_, k) => {
  const locale = AppConfig.locales.find(({ key }) => key === k);
  if (locale) return locale;
  return AppConfig.locales[0];
});
